<template>
  <div class="main_wrapper">
    <transition name="fade">
      <Main>
        <router-view></router-view>
      </Main>
    </transition>
  </div>
</template>

<script>
import SpiderSolitaire from "./views/Spider.vue";
import KlondikeSolitaire from "./views/Klondike.vue";
import Main from "./components/Main";

export default {
  name: "mainTable",
  components: { SpiderSolitaire, KlondikeSolitaire, Main },
  data: function() {
    return {
      chosen: false
    };
  }
};
</script>
<style scoped>
</style>


